<template>
  <div>

    <FieldTitle v-if="readOnly" :model="model" />
    <div v-if="readOnly" class="flex">
      <div class="w-full border bg-graylight-100 rounded">
        <div v-if="text" v-html="readOnlyText" class="p-4 prose text-lg" />
        <div v-else>
          <input type="text" class="nomargin text-lg" :id="guid" v-model="readOnlyText" disabled />
        </div>
      </div>
    </div>

    <div v-else class="flex">
      <div class="w-full pr-0 text-lg">
        <FieldTitle :model="model" />
        <tiny-editor @update="handleUpdate" :value="text" :init="tinyLiteConfig"></tiny-editor>

        <div class="relative">
          <font-awesome-icon v-show="isSaving" icon="spinner" class="animate-spin absolute right-2.5 top-0" />
        </div>
      </div>

      <div class="hidden pr-0 mb-4 xl:block lg:pl-4">
        <CommentPane v-if="!model.deactivateComments" :model="model.comments" :contentGuid="model.contentGuid"
          :pageId="pageId" :fieldTitle="model.title" />
      </div>
    </div>
  </div>
</template>

<script>
import CommentPane from '@/views/components/schema/CommentPane.vue';
import FieldTitle from '@/views/components/schema/common/FieldTitle.vue';
import TinyEditor from '@/components/tiny/tinyEditor.vue';

export default {
  props: {
    model: { type: Object, required: true },
    pageId: { type: String, required: false },
    readOnly: { type: Boolean, required: false },
    preview: { type: Boolean, required: false },
  },
  components: {
    CommentPane,
    FieldTitle,
    TinyEditor,
  },
  data() {
    return {
      type: this.model.type,
      text: this.model.properties.text,
      readOnlyText: this.model.properties.text ? this.model.properties.text : 'Ikke utfylt',
      isSaving: false,
      tinyLiteConfig: {
        height: 300,
        menubar: false,
        statusbar: false,
        plugins: [
          'lists', 'link', 'paste', 'clean', 'autoresize',
        ],
        toolbar: 'bold italic underline | bullist numlist | removeformat link',
        // block_formats: 'Paragraph=p;Heading 2=h2;Heading 3=h3;Heading 4=h4',
        content_style: `
            body {
              font-size: 19px;
              font-family: "Brandon Text", ui-sans-serif, system-ui;
              color: #000000;
              line-height: 1.5; /* Good for readability at 19px */
            }
            h2 { font-size: 28px; font-weight: bold; }
            h3 { font-size: 24px; font-weight: bold; }
            h4 { font-size: 20px; font-weight: bold; text-transform: uppercase; }
          `
      }
    };
  },
  created() {
    this.debouncedSave = this.debounce(this.performSave, 1000);
  },
  methods: {

    debounce(func, wait) {
      let timeout;
      return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
      };
    },
    handleUpdate(input) {
      this.text = input;

      this.debouncedSave(input);
    },

    performSave(input) {
      this.isSaving = true;
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: this.model.contentGuid, value: input, type: this.type, pageId: this.pageId,
        }),
      };

      const self = this;
      fetch(`${window.location.origin}/api/schema/SaveSchemaItem`, requestOptions)
        .then(() => {
          this.$emit('onSave');
          this.$emit('getSchema');
        })
        .then(() => {
          this.$toast.open({
            message: 'Lagret',
            type: 'success',
            dismissible: true,
          });
        })
        .finally(() => {
          self.isSaving = false;
        });
    },
  },
  emits: ['onSave', 'getSchema'],
};
</script>
